<div class="home-page">
  <nav class="home-navigation" aria-label="Navegación principal">
    <a routerLink="/" aria-current="page" class="active"><mat-icon>home</mat-icon>Inicio</a>
    <a routerLink="/units"><mat-icon>church</mat-icon>Comunidades</a>
    @if (canViewInternal()) { <a routerLink="/units/ministry-transfer-requests" class="desktop-link">Pases ministeriales</a> }
    <a routerLink="/profile" class="profile-link"><mat-icon>account_circle</mat-icon>Mi perfil</a>
  </nav>
  <div class="home-content">
    @if (currentUser(); as user) {
      <header class="greeting">
        <div><h1>Hola, {{ greetingName() }}</h1><p>Tu comunidad y las tareas del día, a mano.</p></div>
        <div class="roles">@for (role of roleLabels(); track role) { <span>{{ role }}</span> }</div>
      </header>
      @if (unitsLoading()) {
        <app-loading-state message="Cargando tus unidades..." [spinnerDiameter]="32" />
      } @else {
        @if (unitsError()) {
          <div class="load-error" role="status"><span>No se pudieron cargar todas tus unidades de trabajo.</span><button mat-button (click)="retryUnits()">Reintentar</button></div>
        }
        @if (selectedUnit(); as unit) {
          <section class="unit-context" aria-label="Unidad de trabajo">
            <div class="unit-icon"><mat-icon>church</mat-icon></div>
            <div class="unit-context-copy">
              <span class="eyebrow">{{ canReadSelected() || canCreateService() ? 'Estás trabajando en' : 'Tu comunidad' }}</span>
              @if (units().length > 1) {
                <mat-form-field appearance="fill" subscriptSizing="dynamic">
                  <mat-label>Comunidad o unidad</mat-label>
                  <mat-select [value]="selectedUnitId()" (selectionChange)="selectedUnitId.set($event.value)">
                    @for (option of units(); track option.id) { <mat-option [value]="option.id">{{ option.name }}</mat-option> }
                  </mat-select>
                </mat-form-field>
              } @else { <h2>{{ unit.name }}</h2> }
              @if (unit.ancestorNames?.length) { <p>{{ unit.ancestorNames?.join(' · ') }}</p> }
              @else { <p>{{ unit.levelName }}</p> }
            </div>
            <a [routerLink]="['/units', unit.id]" class="text-link">Ir a {{ unit.levelId === 5 ? 'la comunidad' : 'la unidad' }}<mat-icon>arrow_forward</mat-icon></a>
          </section>
          <div class="quick-actions" aria-label="Accesos frecuentes">
            @if (canCreateService()) {
              <a class="quick-action primary-action" [routerLink]="['/units', unit.id, 'divine-services', 'new']"><mat-icon>event_available</mat-icon><span>Registrar servicio</span></a>
            }
            @if (canReadSelected()) {
              <a class="quick-action" [routerLink]="latestServiceRoute()"><mat-icon>assignment</mat-icon><span>Último servicio</span></a>
              <a class="quick-action" [routerLink]="['/units', unit.id, 'members']"><mat-icon>group</mat-icon><span>Ver miembros</span></a>
            }
            @if (canCreateMember()) {
              <a class="quick-action" routerLink="/people/new" [queryParams]="{ unitId: unit.id }"><mat-icon>person_add</mat-icon><span>Agregar miembro</span></a>
            }
          </div>
        } @else {
          <section class="empty-context"><mat-icon>church</mat-icon><h2>Encontrá tu comunidad</h2><p>Buscá una comunidad para consultar su información.</p><a mat-flat-button color="primary" routerLink="/units">Ver comunidades</a></section>
        }
      }
      @if (pending(); as state) {
        <section class="pending-banner" aria-live="polite">
          <mat-icon>swap_horiz</mat-icon>
          <div>
            @if (state.loading) { <h2>Cargando pases ministeriales...</h2> }
            @else if (state.error) { <h2>No se pudieron cargar los pases ministeriales.</h2> }
            @else { <h2>{{ state.data === 0 ? 'No tenés pases ministeriales pendientes' : state.data + (state.data === 1 ? ' pase ministerial pendiente' : ' pases ministeriales pendientes') }}</h2> }
            <p>Solicitudes dentro de tu ámbito de gestión.</p>
          </div>
          @if (state.error) { <button mat-button (click)="retry()">Reintentar</button> }
          @else { <a routerLink="/units/ministry-transfer-requests" class="text-link">{{ state.data > 0 ? 'Revisar solicitudes' : 'Ver solicitudes' }}<mat-icon>arrow_forward</mat-icon></a> }
        </section>
      }
      @if (dashboard(); as cards) {
        <div class="dashboard-grid">
          <section class="home-card" aria-labelledby="agenda-heading" [attr.aria-busy]="cards.agenda.loading">
            <header><mat-icon>calendar_month</mat-icon><h2 id="agenda-heading">Hoy y mañana</h2></header>
            <div class="card-body" aria-live="polite">
              @if (cards.agenda.loading) { <p class="empty-message">Cargando agenda...</p> }
              @else if (cards.agenda.error) { <p class="empty-message">No se pudo cargar la agenda.</p><button mat-button (click)="retry()">Reintentar</button> }
              @else {
                @for (service of cards.agenda.data; track service.id) {
                  <a class="agenda-event" [routerLink]="serviceRoute(service)">
                    <span class="date-badge"><span>{{ service.startAt | date:'MMM' }}</span><strong>{{ service.startAt | date:'dd' }}</strong></span>
                    <span class="event-copy"><strong>{{ service.divineServiceTypeName || 'Servicio divino' }}</strong><span>{{ service.startAt | date:'EEE HH:mm' }} · {{ service.organizationUnitName }}</span></span>
                    <mat-icon>chevron_right</mat-icon>
                  </a>
                } @empty { <p class="empty-message">Sin servicios programados para hoy y mañana.</p> }
              }
            </div>
            <footer><a class="text-link" [routerLink]="['/units', selectedUnitId(), 'agenda']">Ver agenda completa<mat-icon>arrow_forward</mat-icon></a></footer>
          </section>
          <section class="home-card" aria-labelledby="latest-heading" [attr.aria-busy]="cards.latest.loading">
            <header><mat-icon>bar_chart</mat-icon><h2 id="latest-heading">Último servicio</h2></header>
            <div class="card-body" aria-live="polite">
              @if (cards.latest.loading) { <p class="empty-message">Cargando último servicio...</p> }
              @else if (cards.latest.error) { <p class="empty-message">No se pudo cargar el último servicio.</p><button mat-button (click)="retry()">Reintentar</button> }
              @else if (cards.latest.data; as service) {
                <p class="service-date">{{ service.startAt | date:'EEEE d MMM · HH:mm' }} · {{ service.organizationUnitName }}</p>
                <dl class="attendance-stats"><div><dt>Mayores</dt><dd>{{ service.totalAdults ?? 0 }}</dd></div><div><dt>Menores</dt><dd>{{ service.totalMinors ?? 0 }}</dd></div><div><dt>Total registrado</dt><dd>{{ (service.totalAdults ?? 0) + (service.totalMinors ?? 0) }}</dd></div></dl>
              } @else { <p class="empty-message">Todavía no hay servicios registrados hasta hoy.</p> }
            </div>
            @if (cards.latest.data; as service) {
              <footer><a class="text-link" [routerLink]="serviceRoute(service)">Consultar asistencia<mat-icon>arrow_forward</mat-icon></a></footer>
            }
          </section>
        </div>
      }
      @if (hasResponsibilities()) {
        <details class="responsibilities">
          <summary>Tus responsabilidades</summary>
          @if (user.activeMinistry; as ministry) {
            <p>Ministerio: {{ ministry.name }} · <a [routerLink]="['/units', ministry.unitId]">{{ ministry.unitName }}</a></p>
          }
          @for (appointment of user.activeAppointments; track $index) {
            <p>Encargo: {{ appointment.name }} · <a [routerLink]="['/units', appointment.unitId]">{{ appointment.unitName }}</a></p>
          }
          @for (assignment of user.activeAssignments; track $index) {
            <p>Nombramiento: {{ assignment.name }} · <a [routerLink]="['/units', assignment.unitId]">{{ assignment.unitName }}</a></p>
          }
          @for (activity of user.activeActivities; track $index) {
            <p>Actividad: {{ activity.name }}{{ activity.role ? ' · ' + activity.role : '' }} · <a [routerLink]="['/units', activity.unitId]">{{ activity.unitName }}</a></p>
          }
        </details>
      }
      <footer class="home-footer">
        @if (user.personId) { <a [routerLink]="['/people', user.personId]" class="text-link">Mi ficha<mat-icon>north_east</mat-icon></a> }
        <a routerLink="/profile" class="text-link">Mi perfil<mat-icon>north_east</mat-icon></a>
      </footer>
    } @else {
      <app-loading-state message="Cargando tu información..." description="Estamos preparando tu inicio" />
    }
  </div>
</div>
